import React from "react"
export function OmanFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Oman"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__oman" fillRule="nonzero">
          <path id="prefix__Rectangle" fill="#D80027" d="M0 0h24v16H0z" />
          <path
            id="prefix__Rectangle"
            stroke="#CCC"
            strokeWidth={0.5}
            fill="#FFF"
            d="M9.25.25h14.5v7.5H9.25z"
          />
          <path
            id="prefix__Rectangle"
            fill="#D80027"
            d="M0 0h10v16H0zM10 6h14v5H10z"
          />
          <path
            id="prefix__Path"
            fill="#F0F0F0"
            d="M8.9 3.5l-.7-.7-.5.5-.5-.5-.8.7.5.5-.5.5.8.7.5-.4.5.4.7-.7-.5-.5z"
          />
          <path id="prefix__Rectangle" fill="#6DA544" d="M10 10.8h14V16H10z" />
        </g>
      </g>
    </svg>
  )
}
